import { Heart } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function FavoriteButton({ type, itemId, className = "" }) {
  const { user, isFav, toggleFavorite } = useAuth();
  const nav = useNavigate();
  const active = isFav(type, itemId);

  const onClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) { nav("/connexion"); return; }
    const fav = await toggleFavorite(type, itemId);
    toast(fav ? "Ajouté à vos favoris ❤️" : "Retiré des favoris");
  };

  return (
    <button data-testid={`fav-${type}-${itemId}`} onClick={onClick}
      className={`grid place-items-center rounded-full transition-all ${active ? "text-[#FF5A00]" : "text-white"} ${className}`}
      aria-label="Favori">
      <Heart className={`w-5 h-5 ${active ? "fill-[#FF5A00]" : ""}`} />
    </button>
  );
}
